import { useQuery } from 'react-query';
import { ExtractFnReturnType, QueryConfig } from 'src/lib/react-query';
import useNotification from 'src/store/Notifications/useNotification';
import { axiosDefaultApi } from 'src/lib/axios';


const getAllAreasList = async (): Promise<IGetAreasList []> => {
  return axiosDefaultApi.get(`api/Areas/GetAreas`);
};

type QueryFnType = typeof getAllAreasList;

type UseGetAllAreasListOptions = {
  config?: QueryConfig<QueryFnType>;
};

export const useGetAllAreasList = ({ config }: UseGetAllAreasListOptions = {} ) => {
  const {addNotification, setIsNotificationVisible} = useNotification();
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: ['getAllAreasList'],
    queryFn: () => getAllAreasList(),
    onError: (error) =>{
      addNotification(`Υπήρξε κάποιο πρόβλημα στην ανάκτηση των περιοχών.`, 500);
      setIsNotificationVisible(true)
      console.log(error)
    }
  });
};